import { ProjectType } from "@/data/projects";

interface ProjectCardProps {
  project: ProjectType;
  onClick?: () => void;
}

const ProjectCard = ({ project, onClick }: ProjectCardProps) => {
  return (
    <div 
      className="gallery-item rounded-lg overflow-hidden shadow-md cursor-pointer"
      onClick={onClick}
    >
      <img 
        src={project.image} 
        alt={project.title} 
        className="w-full h-64 object-cover"
      />
      <div className="p-4 bg-white">
        <h3 className="text-lg font-heading font-bold text-primary truncate">
          {project.title}
        </h3>
        <p className="text-sm text-gray-600">{project.location}</p>
      </div>
    </div>
  );
};

export default ProjectCard;
